<!--<script>
    $('.collapse').collapse();
</script>-->
<nav class="toolbar navbar navbar-light toolbar-no-button">
    <form class="form-inline" autocomplete="off">
        <!--<button class="btnback btn btn-outline-success"><i class="fa fa-chevron-left"></i></button>-->
    </form>
</nav>
<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <h4>Bulk CAS Usuarios Cexveg</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                           
                        </div>
                    </a>

                    <div class="card-body">

                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                       

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="button" title="Realiza una búsqueda" (click)="onBulk()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
            <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Usuarios Actualizados
                    </div>

                    <div class="card-body-grid">

                        <table class="table table-list table-responsive table-sm">
                            <thead>
                                <tr>
                                    <th>NIF</th>
                                    <th>Nombre</th>
                                    <th>Apellidos</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of listUsuario">



                                    <td scope="col" class="td-list">{{item.Nif}}</td>
                                    <td scope="col" class="td-list">{{item.Nombre}}</td>
                                    <td scope="col" class="td-list">{{item.Apellidos}}</td>
                                    <td scope="col" class="td-list">{{item.Email}}</td>

                                </tr>

                            </tbody>
                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</form>
